import { render, staticRenderFns } from "./SpacePicker.vue?vue&type=template&id=020ef519&"
import script from "./SpacePicker.vue?vue&type=script&lang=js&"
export * from "./SpacePicker.vue?vue&type=script&lang=js&"
import style0 from "./SpacePicker.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports